class Slider extends HTMLElement {
    constructor () {
        super();
        this.initSwiper();

        this.addEventListener('mouseenter', () => this.pauseAutoplay());
        this.addEventListener('mouseleave', () => this.resumeAutoplay());
    }

    initSwiper() {
        this.swiper = new Swiper(this, {
            slidesPerView: 4.47,
            spaceBetween:14,
            loop: true,
            loopAdditionalSlides: 8,
            centeredSlides: true,
            initialSlide: 4,
            speed: 8000,
            allowTouchMove: false,
            autoplay: {
                delay: 1,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: this.closest('.section-instagram')?.querySelector('.swiper-button-next'),
                prevEl: this.closest('.section-instagram')?.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                100: {
                    slidesPerView: 1.5,
                    spaceBetween: 10,
                },
                500: {
                    slidesPerView: 2.47,
                    spaceBetween: 12,
                },
                767: {
                    slidesPerView: 3.47,
                    spaceBetween: 14,
                },
                1024: {
                    slidesPerView: 4.47,
                    spaceBetween: 14,
                },
            },
        });
    }

    update() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
        }
        this.initSwiper();
    }

    pauseAutoplay() {
        if (!this.swiper || this.swiper.destroyed) return;
        const currentX = this.getWrapperTranslateX();
        this.swiper.autoplay.stop();
        this.swiper.setTransition(0);
        this.swiper.setTranslate(currentX);
        this.swiper.animating = false;
    }

    resumeAutoplay() {
        if (!this.swiper || this.swiper.destroyed) return;
        this.swiper.autoplay.start();
    }

    getWrapperTranslateX() {
        const transform = getComputedStyle(this.swiper.wrapperEl).transform;
        if (transform === 'none') return this.swiper.translate;
        const match = transform.match(/matrix(3d)?\(([^)]+)\)/);
        if (!match) return this.swiper.translate;
        const values = match[2].split(',').map((v) => parseFloat(v.trim()));
        return values.length === 16 ? values[12] : values[4];
    }

}

customElements.define('custom-slider', Slider);